import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

/* ==============================
   FIREBASE CONFIG
   Replace with your project's config from:
   Firebase Console → Project Settings → Your apps → Config
   ============================== */
const firebaseConfig = {
  apiKey: "AIzaSyCWMVuW3rfaJXTnmpUDTQrX4cq0iOQyMVA",
  authDomain: "binhxapxam-5e6de.firebaseapp.com",
  databaseURL: "https://binhxapxam-5e6de-default-rtdb.firebaseio.com",
  projectId: "binhxapxam-5e6de",
  storageBucket: "binhxapxam-5e6de.firebasestorage.app",
  messagingSenderId: "175703539141",
  appId: "1:175703539141:web:ef43fd36b476e0d8665fac",
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// Cloud Function callables — 30s timeout (matches CF server timeout)
export const callDealCards = httpsCallable(functions, 'dealCards', { timeout: 30000 });
export const callPerformNemDraw = httpsCallable(functions, 'performNemDraw', { timeout: 30000 });
export const callScoreRound = httpsCallable(functions, 'scoreRound', { timeout: 30000 });
export const callValidateArrangement = httpsCallable(functions, 'validateArrangement', { timeout: 30000 });
export const callSubmitArrangement = httpsCallable(functions, 'submitArrangement', { timeout: 30000 });
export const callSetReady = httpsCallable(functions, 'setReady', { timeout: 30000 });
export const callUpdateRules = httpsCallable(functions, 'updateRules', { timeout: 30000 });
export const callRejoinGame = httpsCallable(functions, 'rejoinGame', { timeout: 30000 });

export async function ensureAnonymousAuth() {
  if (auth.currentUser) return auth.currentUser.uid;
  const cred = await signInAnonymously(auth);
  return cred.user.uid;
}
